import script from "./FirstAcess.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstAcess.vue?vue&type=script&setup=true&lang=js"

import "./FirstAcess.vue?vue&type=style&index=0&id=96fb5e88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96fb5e88"]])

export default __exports__